// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import VueBus from './vue-bus';
import * as echarts from 'echarts'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "../static/theme/index.css"
import './assets/css/_global.scss' /*引入全局样式*/
import Global from './assets/js/global_tool/Global.js' /*引入全局边框工具*/
import base64 from './assets/js/global_tool/sys_tool/base64'/*base64编码工具h*/
import './assets/icon_font/iconfont.css'/*引入图标*/

var cesiumjs = ""
import axios from 'axios'
import register_center_new from './assets/js/global_tool/sys_tool/register_center_new'/*新版注册中心文件*/
import '../static/mapResource/mapbox-gl-compare'/*引入地图对比函数*/
import VideoPlayer from 'vue-video-player'
import shebei_marker from "./studio/twoDMap/shebei_marker";
window.shebei_marker = Vue.extend(shebei_marker)

import '@/components/approverFlow/DynamicForm/icons'
import FormControls from '@/components/approverFlow/FormControls/index.js'
import './assets/js/videoPlayer.js'
Vue.use( FormControls )

Vue.use(VideoPlayer);
Vue.use(ElementUI);
Vue.use(VueBus);
Vue.config.productionTip = false;


Vue.prototype.$axios=axios;
Vue.prototype.$echarts = echarts;
Vue.prototype.GLOBAL = Global;
Vue.prototype.successCode = 0;
window.GLOBAL = Global

Vue.prototype.register_center = new register_center_new();

/*自动获取焦点*/
Vue.directive('focus',{
  inserted: function(el) {
    el.querySelector("input").focus();
  }
})

/*定义监听刷新的混入对象*/
window.sys_refresh_mixin = {
  created() {
    this.minxin_handle_last_data()
  },
  mounted() {
    window.addEventListener("beforeunload", this.minxin_handle_beforeunload,false);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.minxin_handle_beforeunload,false);
  },
  methods:{

    /*处理上次是否有存储的数据*/
    minxin_handle_last_data(){
      if(!this.func_id){return }
      let last_data = sessionStorage.getItem(this.func_id)
      sessionStorage.removeItem(this.func_id)
      if(last_data){
        last_data = JSON.parse(last_data)
        let keys = Object.keys(last_data)
        keys.forEach(item => {
          this[item] = last_data[item]
        })

        if(this.handle_last_data){
          this.handle_last_data(last_data)
        }
      }
    },

    /*处理刷新*/
    minxin_handle_beforeunload(){
      if(this.handle_beforeunload){
        this.handle_beforeunload()
      }
    },
  }
}

//注册全局指令-dialog拖动
Vue.directive('cardDrag', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el,binding,vnode,oldVnode) {
    const dialogHeaderEl = el.querySelector('.el-card__header');
    const dragDom = el;
    dialogHeaderEl.style.cursor = 'move';

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;
      document.body.classList.add('no-select');
      // 获取到的值带px 正则匹配替换
      let styL, styT;

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if(sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
      }else {
        styL = +sty.left.replace(/\px/g, '');
        styT = +sty.top.replace(/\px/g, '');
      };

      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX;
        const t = e.clientY - disY;

        // 移动当前元素
        dragDom.style.left = `${l + styL}px`;
        dragDom.style.top = `${t + styT}px`;

        //将此时的位置传出去
        //binding.value({x:e.pageX,y:e.pageY})
      };

      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
  }
});
Vue.directive('thumbnails',{
  inserted:function (element,binding,vnode,oldVnode) {
    element.querySelector('.thumbnails-button').onclick = (e) => {

      let classNameArr=element.className.split(' '),
        flag=false,
        index=-1
      for(let i=classNameArr.length;i>=0;i--){
        if(classNameArr[i]==='thumbnails'){
          index=i
          flag=true
          break
        }
      }
      if(flag && index>0){
        classNameArr.splice(index, 1);
      }else{
        classNameArr.push('thumbnails')
      }
      element.className=classNameArr.join(' ')
    }
  }
})

let mainVue = new Vue({
  el: '#app',
  router,/*路由*/
  store,/*vuex*/
  components: { App },
  template: '<App/>'
})


/*vue实例绑定到window*/
window.vue = mainVue;
window.base64 = base64;

/*不同坐标系地图实例绑定到window*/
import mapbox3857 from 'mapbox-gl';
import mapbox4490 from '@cgcs2000/mapbox-gl'
/*import mapbox4490 from '../static/mapResource/mapbox_gl_4490';*/

mapbox3857.accessToken = 'pk.eyJ1IjoibGFuYm96aGlndWFuZyIsImEiOiJjazQ2cDBtbXMwNndpM2RxbDFwa2prZmFsIn0.oIMr9pRe-k7dgvNSi2Ue5w';
mapbox4490.accessToken = 'pk.eyJ1IjoibGFuYm96aGlndWFuZyIsImEiOiJjazQ2cDBtbXMwNndpM2RxbDFwa2prZmFsIn0.oIMr9pRe-k7dgvNSi2Ue5w';

window.mapbox3857 = mapbox3857;
window.mapbox4490 = mapbox4490;



// WEBPACK FOOTER //
// ./src/main.js